/**
 * Replacement functions from https://youmightnotneedjquery.com/ etc.
 * Let's look forward and plan for reducing our reliance on jQuery.
 */

/**
 * Replacement for $(element).width()
 * Returns a unitless Number for use in mathematic calculations
 * @param {HTMLElement} element
 * @throws {TypeError} if element is not an HTMLElement
 * @returns {Number}
 */
const getElementWidth = (element) => {
  return parseFloat(getComputedStyle(element, null).width.replace('px', ''));
};

/**
 * Replacement document.ready
 * @param {Function} fn
 */
const ready = (fn) => {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

export {
  getElementWidth,
  ready,
};
